import { useState } from 'react';
import TabsCustom from '@/components/_common/TabsCustom';
import {
  BankAccountSettings,
  BankAccountSettingsFormValues,
} from '@/core/domain/enterprise/BankAccountsSettings/BankAccountsSettings.types';
import { Badge, Form, Typography } from 'antd';
import ConfigBankSlipForm from '../ConfigBankSlipForm';
import ConfigBankSlipCertificateForm from '../ConfigBankSlipCertificateForm';
import ConfigBankSlipDiscountForm from '../ConfigBankSlipDiscountForm';
import ConfigBankSlipFineForm from '../ConfigBankSlipFineForm';
import ConfigBankSlipInterestForm from '../ConfigBankSlipInterestForm';
import ConfigBankSlipMessagesForm from '../ConfigBankSlipMessagesForm';
import ConfigBankSlipProtestForm from '../ConfigBankSlipProtestForm';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';

import { bankConfig } from '@/core/domain/financial/Boletos/Boletos.dictionary';

interface Props {
  bankAccount?: BankAccount;
  bankAccountSettings?: BankAccountSettings;
  tabErrors: string[];
}

export default function ConfigTabsForm({
  bankAccount,
  bankAccountSettings,
  tabErrors,
}: Props) {
  const form = Form.useFormInstance<BankAccountSettingsFormValues>();

  const tabIconError = (key: string) =>
    tabErrors.includes(key) ? <Badge dot /> : null;

  const [menuKey, setMenuKey] = useState('general');

  const agreementInstantRegister = Form.useWatch(
    ['general', 'agreementInstantRegister'],
    form,
  );

  const bankMapFields = bankAccount
    ? bankConfig[bankAccount?.bank.code as string]
    : null;

  const viewCertificate =
    Boolean(agreementInstantRegister) &&
    bankAccountSettings?.bankAccountAgreement &&
    bankMapFields?.fields.certificate?.required;

  return (
    <TabsCustom key="general" activeKey={menuKey} onChange={setMenuKey}>
      <TabsCustom.Item
        label="Geral"
        key="general"
        icon={tabIconError('general')}
      >
        <div style={{ minHeight: '200px' }}>
          <Typography.Title level={4}>Convênio</Typography.Title>

          <ConfigBankSlipForm form={form} bankAccount={bankAccount} />
        </div>
      </TabsCustom.Item>

      {viewCertificate && (
        <TabsCustom.Item
          label="Certificado"
          key="certificate"
          icon={tabIconError('certificate')}
        >
          <div style={{ minHeight: '200px' }}>
            <ConfigBankSlipCertificateForm
              form={form}
              bankAccountSettings={bankAccountSettings}
              bankAccountId={bankAccount?.id}
            />
          </div>
        </TabsCustom.Item>
      )}

      <TabsCustom.Item
        label="Desconto"
        key="discount"
        icon={tabIconError('discount')}
      >
        <div style={{ minHeight: '200px' }}>
          <ConfigBankSlipDiscountForm form={form} bankAccount={bankAccount} />
        </div>
      </TabsCustom.Item>

      <TabsCustom.Item
        label="Juros"
        key="interest"
        icon={tabIconError('interest')}
      >
        <div style={{ minHeight: '200px' }}>
          <ConfigBankSlipInterestForm form={form} />
        </div>
      </TabsCustom.Item>

      <TabsCustom.Item label="Multa" key="fine" icon={tabIconError('fine')}>
        <div style={{ minHeight: '200px' }}>
          <ConfigBankSlipFineForm form={form} bankAccount={bankAccount} />
        </div>
      </TabsCustom.Item>

      <TabsCustom.Item
        label="Protesto"
        key="protest"
        icon={tabIconError('protest')}
      >
        <div style={{ minHeight: '200px' }}>
          <ConfigBankSlipProtestForm form={form} />
        </div>
      </TabsCustom.Item>

      <TabsCustom.Item
        label="Mensagens"
        key="messages"
        icon={tabIconError('messages')}
      >
        <div style={{ minHeight: '200px' }}>
          <ConfigBankSlipMessagesForm form={form} />
        </div>
      </TabsCustom.Item>
    </TabsCustom>
  );
}
